import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCardSubtitle,
  CCol,
  CContainer,
  CHeader,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import Pagination from 'react-js-pagination'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { DefaultInputWithIcon } from 'src/components/common/input'
import { get, post } from 'src/utils/apiManager'
import Lottie from 'lottie-react'
import groovyWalkAnimation from './groovyWalk.json'

function DeliveredOrders() {
  const [deliveredOrders, setDeliveredOrders] = useState()
  const [completeOrders, SetCompleteOrders] = useState(true)
  const [searchItem, setSearchItem] = useState('')
  const [totalPages, setTotalPages] = useState(0)
  const [count, setCount] = useState()
  const [deletedArray, setDeletedArray] = useState([])
  const [pageData, setPageData] = useState({
    page: 1,
    perPage: 10,
    searchItem: '',
  })
  let data = {
    orderStatus: 'deliverd',
    driverStatus: 'deliverd',
  }

  const getData = () => {
    get(
      `/admin/order-status/order-list?page=${pageData?.page || 1}&perPage=${
        pageData?.perPage || 10
      }&searchItem=${pageData?.searchItem || ''}&orderStatus=${data.orderStatus}&driverStatus=${
        data.driverStatus
      }`,
    ).then((res) => handleResponse(res))
  }

  const handleResponse = (res) => {
    // console.log(res)
    // console.log(res.data.deliverdOrders[0].data)
    if (res.status === true) {
      // toast.success(res.message)
      setTimeout(() => {
        SetCompleteOrders(false)
      }, 1500)
      setDeliveredOrders(res?.data?.deliverdOrders[0]?.data)
      setTotalPages(res?.data?.deliverdOrders[0]?.metadata[0]?.page)
      setCount(res?.data?.deliverdOrders[0]?.metadata[0]?.total)
    } else {
      toast.error('No deliverd order ')
    }
  }
  const onSearchCLick = () => {
    setPageData({
      ...pageData,
      searchItem: searchItem,
    })
  }
  const changePage = (index) => {
    setPageData({
      ...pageData,
      page: index,
    })
  }
  useEffect(() => {
    getData()
  }, [pageData])

  const handleCheck = (id) => {
    let findValue = deletedArray.includes(id)
    if (findValue) {
      let filterData = deletedArray?.filter((item) => item != id)
      setDeletedArray(filterData)
    } else {
      setDeletedArray((prev) => [...prev, id])
    }
  }

  const deleteOrders = () => {
    post(`admin/placed-order/deleted-order`, deletedArray).then((data) =>
      handleDeletedResponse(data),
    )
  }

  const handleDeletedResponse = (data) => {
    if (data?.status == true) {
      toast.success(data?.message)
      setDeletedArray([])
      //   get(
      //     `/admin/placed-order/order-placed-list?page=${pageData?.page || 1}&perPage=${
      //       pageData?.perPage || 10
      //     }&searchItem=${pageData?.searchItem || ''}&from_date=${searchDate ? searchDate : ''}`,
      //   ).then((res) => handleResponse(res))
      getData()
    }
  }

  return (
    <>
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
      <CContainer fluid>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard className="p-4">
                <CHeader>
                  <div className="d-flex" style={{ flexDirection: 'column' }}>
                    <CCardSubtitle as="h4">Deliverd Orders</CCardSubtitle>
                    {deletedArray.length > 0 && (
                      <button className="btn btn-danger mt-2 text-white" onClick={deleteOrders}>
                        Delete
                      </button>
                    )}
                  </div>
                  <CRow>
                    <CCol md="8">
                      <DefaultInputWithIcon
                        type={'text'}
                        placeholder="Search"
                        customType={'search'}
                        value={searchItem}
                        onClick={onSearchCLick}
                        onChange={(e) => {
                          onSearchCLick()
                          setSearchItem(e.target.value)
                        }}
                      />
                    </CCol>
                  </CRow>
                </CHeader>
                {completeOrders !== true ? (
                  <CCardBody>
                    <CTable bordered hover responsive>
                      <CTableHead>
                        <CTableRow>
                          <CTableHeaderCell>S. No</CTableHeaderCell>
                          <CTableHeaderCell>Order ID</CTableHeaderCell>
                          <CTableHeaderCell>Order Status</CTableHeaderCell>
                          <CTableHeaderCell>User Name</CTableHeaderCell>
                          <CTableHeaderCell>Mobile Number</CTableHeaderCell>
                          <CTableHeaderCell>Driver Name</CTableHeaderCell>
                          <CTableHeaderCell>Driver Mobile Number</CTableHeaderCell>
                          <CTableHeaderCell>Driver Status</CTableHeaderCell>
                        </CTableRow>
                      </CTableHead>
                      <CTableBody>
                        {deliveredOrders?.map((item, index) => {
                          return (
                            <CTableRow key={index} onClick={() => handleCheck(item._id)}>
                              <CTableDataCell >
                                {index + 1}
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    style={{ marginLeft: '2px', marginTop: '-20px' }}
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                    checked={deletedArray?.includes(item._id)}
                                    // onChange={() => handleCheck(item._id)}
                                  />
                                </div>
                              </CTableDataCell>
                              <CTableDataCell style={{ textDecoration: 'none', color: '#80861C' }}>
                                #{item?.orderId}
                                {/* <Link to={{ pathname: `/admin/placed-order/item-detail/${btoa(item._id)}/${btoa(item.orderId)}`, state: item }} style={{ textDecoration: 'none', color: '#80861C' }}>#{item?.orderId}</Link> */}
                              </CTableDataCell>
                              <CTableDataCell>
                                {item.orderStatus == 'deliverd' ? (
                                  <CButton
                                    size="sm"
                                    style={{ backgroundColor: '#2E7D32', border: '#2E7D32' }}
                                    outline={item?.orderStatus}
                                  >
                                    <span>
                                      <strong>Deliverd</strong>
                                    </span>
                                  </CButton>
                                ) : (
                                  ''
                                )}
                              </CTableDataCell>
                              <CTableDataCell>
                                {item?.userId.map((i, k) => {
                                  return <span>{i.username}</span>
                                })}
                              </CTableDataCell>
                              <CTableDataCell>
                                {item?.userId.map((i, k) => {
                                  return <span>{i.mobile}</span>
                                })}
                              </CTableDataCell>
                              <CTableDataCell>
                                {item?.pickup_driver.map((i, k) => {
                                  return <span>{i.username}</span>
                                })}
                              </CTableDataCell>
                              <CTableDataCell>
                                {item?.pickup_driver.map((i, k) => {
                                  return <span>{i.mobile}</span>
                                })}
                              </CTableDataCell>
                              <CTableDataCell>
                                {item.driverStatus == 'deliverd' ? (
                                  <CButton
                                    size="sm"
                                    style={{ backgroundColor: '#2E7D32', border: '#2E7D32' }}
                                    outline={item?.driverStatus}
                                  >
                                    <span>
                                      <strong>Deliverd</strong>
                                    </span>
                                  </CButton>
                                ) : (
                                  ''
                                )}
                              </CTableDataCell>
                            </CTableRow>
                          )
                        })}
                      </CTableBody>
                    </CTable>
                    {!deliveredOrders?.length && (
                      <>
                        <h1>No Data</h1>
                      </>
                    )}
                    {deliveredOrders?.length ? (
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={pageData?.page}
                        itemsCountPerPage={pageData?.perPage}
                        totalItemsCount={count}
                        pageRangeDisplayed={5}
                        onChange={changePage}
                      />
                    ) : (
                      ''
                    )}
                  </CCardBody>
                ) : (
                  <div className="lodderClass" style={{ width: '50%', marginLeft: '20%' }}>
                    <Lottie animationData={groovyWalkAnimation} />
                  </div>
                )}
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </>
  )
}

export default DeliveredOrders
